import type { NodeDefinition } from "~/nodes/types";

export const sphereNode: NodeDefinition = {
  type: "sphere",
  label: "Sphere",
  category: "Curves",
  inputs: [
    {
      key: "rad",
      label: "Radius",
      socket: "number",
      control: { kind: "number", key: "rad", label: "rad", step: 1 },
    },
    {
      key: "k",
      label: "K",
      socket: "number",
      control: { kind: "number", key: "k", label: "k", step: 0.1 },
    },
    {
      key: "k2",
      label: "K2",
      socket: "number",
      control: { kind: "number", key: "k2", label: "k2", step: 0.1 },
    },
  ],
  outputs: [{ key: "v3", label: "Vector", socket: "vector" }],
  controls: [],
  defaults: { rad: 50, k: 3, k2: 1 },

  compute(ctx) {
    const r = ctx.number("rad", 50);
    const k = ctx.number("k", 3);
    const k2 = ctx.number("k2", 1);

    return {
      v3: {
        x: (t: number) => r * Math.sin(k * t) * Math.cos(k2 * t),
        y: (t: number) => r * Math.sin(k * t) * Math.sin(k2 * t),
        z: (t: number) => r * Math.cos(k * t),
      },
    };
  },
};
